function componente(){
    return(
        <div className="App">
            esta es mi prueba de un nuevo componente
        </div>
    );
}
export default componente;